import { render } from "./VideoComponent.vue?vue&type=template&id=3062f8c9&scoped=true"
import script from "./VideoComponent.vue?vue&type=script&lang=js"
export * from "./VideoComponent.vue?vue&type=script&lang=js"

import "./VideoComponent.vue?vue&type=style&index=0&id=3062f8c9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3062f8c9"]])

export default __exports__